import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// libraries
import $ from 'jquery';

import GenericFormPopUp from '../../generic_components/GenericFormPopUp';

import * as CONSTANTS from '../../constants';
import * as CONFIG from '../../config';
import * as UTILS from '../../utils/utilFunctions';
import TEXT_GENERAL from '../../text';

const CONTACT_TYPE_DROPDOWN_CONTENT = require('../../general/staticContent/contactTypeDropDown');
const BOOKING_DROPDOWN_CONTENT = require('../../general/staticContent/bookingDropDown');
const { getStatusOptionsForBooking } = require('../../general/staticContent/statusDropDown');

function prepareEmployeesKeyValuePairs(employees) {
  const mappedDropDownEntries = [];
  if (employees && employees.length > 0) {
    employees.forEach(employee => {
      if (employee.lastname) {
        const value = employee.id;
        const label = `${employee.firstname || ''} ${employee.lastname}`;
        const mappedEmployee = { value, label };
        mappedDropDownEntries.push(mappedEmployee);
      }
    });
  }
  return mappedDropDownEntries;
}

function prepareProjectsKeyValuePairs(projects) {
  const mappedDropDownEntries = [];
  if (projects && projects.length > 0) {
    projects.forEach(project => {
      if (project.id) {
        const value = project.id;
        const label = project.projectNumber;
        const mappedProject = { value, label };
        // prevent duplicates - only push to mapped array if entry doesn't exist yet
        if (!mappedDropDownEntries.map(entry => entry.value).includes(project.id)) mappedDropDownEntries.push(mappedProject);
      }
    });
  }
  return mappedDropDownEntries;
}

class CandidatePastContactUpdatePopUpContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.form = this.generateFormFields();

    // error handling required for API calls
    this.errorHandling = UTILS.errorHandling.bind(this);

    this.filteredProjects = props.projects;
    if (CONSTANTS.isLienert) {
      this.filteredProjects = this.filteredProjects.filter(project => project.status === 'In Bearbeitung');
    }
  }

  updateAPICall = updatedData => {
    const tokenFromLocalStorage = window.sessionStorage.getItem('token');
    const url = CONSTANTS.updateCandidateSubSchemaURL;

    const payload = {
      candidateId: this.props.candidateId,
      subSchemaName: 'pastContacts',
      subSchemaId: this.props.entryId,
      subSchemaUpdatedData: updatedData
    };
    if (Object.keys(updatedData).length > 0) {
      console.log(`API ${url} request`, payload);
      $.ajax({
        url,
        method: 'POST',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        headers: { 'x-auth': tokenFromLocalStorage },
        data: JSON.stringify(payload),
        timeout: CONFIG.ajaxTimeout
      })
        .done((responseBody, status) => {
          console.log(`API /${url} response`, responseBody, status);
          this.props.handleSnackbarOpen(TEXT_GENERAL.snackBarTexts.updateSuccess);
          this.props.refreshCandidate();
          this.props.handleClose();
        })
        .fail(err => {
          this.errorHandling(err, url);
        });
    } else {
      this.props.handleSnackbarOpen(TEXT_GENERAL.snackBarTexts.noUpdate);
    }
  };

  generateFormFields() {
    const forms = {
      formFields: {
        contactDate: {
          value: UTILS.formatDateForDateField(this.props.data.contactDate),
          label: 'Datum des Kontakts',
          type: 'date'
        },
        intermediary: {
          value: this.props.data.intermediary ? this.props.data.intermediary.id : '',
          label: 'Durch',
          type: 'dropDown',
          content: prepareEmployeesKeyValuePairs(this.props.employees)
        },
        contactType: {
          value: this.props.data.contactType,
          label: 'Art des Kontakts',
          type: 'dropDown',
          content: CONTACT_TYPE_DROPDOWN_CONTENT
        },
        project: {
          value: this.props.data.project,
          label: 'Auftrag',
          type: 'dropDown',
          content: prepareProjectsKeyValuePairs(this.filteredProjects)
        },
        booking: {
          value: this.props.data.booking || '',
          label: 'Buchung',
          type: 'dropDown',
          content: BOOKING_DROPDOWN_CONTENT
        },
        bookingStatus: {
          value: this.props.data.bookingStatus || '',
          label: 'Buchungsstatus',
          type: 'dropDown',
          content: formFields => getStatusOptionsForBooking(formFields.booking.value),
          showIf: formFields => (formFields.booking.value || '').startsWith('Buchung Paket')
        },
        subject: {
          value: this.props.data.subject,
          label: 'Betreff',
          customClass: 'col-12 mb-2'
        },
        comment: {
          value: this.props.data.comment,
          label: 'Notiz',
          type: 'editor',
          customClass: 'col-12 mt-4 mb-2',
          additionalProps: { init: { height: 250 } }
        }
      }
    };

    return forms;
  }

  render() {
    this.form = this.generateFormFields();
    return (
      <GenericFormPopUp
        open={this.props.open}
        headlineText="Eintrag ändern"
        genericFormProps={{
          formFields: this.form.formFields,
          isUpdate: true,
          handleSubmit: this.updateAPICall,
          handleClose: this.props.handleClose
        }}
      />
    );
  }
}
CandidatePastContactUpdatePopUpContainer.defaultProps = {
  data: {}
};

CandidatePastContactUpdatePopUpContainer.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,

  // data
  candidateId: PropTypes.string.isRequired,
  entryId: PropTypes.string.isRequired,
  data: PropTypes.object,
  // snackBar
  handleSnackbarOpen: PropTypes.func.isRequired,
  refreshCandidate: PropTypes.func.isRequired,
  employees: PropTypes.array.isRequired,
  projects: PropTypes.array.isRequired
};

export default CandidatePastContactUpdatePopUpContainer;
